import script from "./pagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./pagination.vue?vue&type=script&lang=ts&setup=true"

import "./pagination.vue?vue&type=style&index=0&id=65d09b89&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d09b89"]])

export default __exports__